import { Link } from "@tanstack/react-router";
import { SearchBar } from "@/features/search/search-bar/search-bar";

const QUICK_CHIPS = [
  { label: "Blow-outs", q: "blow out" },
  { label: "Gel manicure", q: "gel manicure" },
  { label: "Facials", q: "facials" },
  { label: "Brow lamination", q: "brow lamination" },
  { label: "Men's cut", q: "mens cut" },
] as const;

function HeroSection() {
  return (
    <section className="relative -mt-[69px] bg-linear-to-b from-electric-50 from-50% to-paper pt-[69px]">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center px-5 py-12 text-center md:py-16">
        <h1 className="mb-4 font-display text-[clamp(36px,7vw,64px)] font-bold leading-[1.1] tracking-[-0.025em]">
          Find your next appointment
        </h1>
        <p className="mb-8 max-w-[640px] text-balance text-[16px] leading-normal text-slate md:text-[18px]">
          Explore salons, compare services, and find a time that suits you.
        </p>

        <div className="flex w-full max-w-[900px] flex-col items-center gap-3">
          <div className="w-full">
            <SearchBar mode="expanded" large />
          </div>

          <nav className="flex flex-wrap justify-center gap-2" aria-label="Treatment searches">
            {QUICK_CHIPS.map((chip) => (
              <Link
                key={chip.q}
                to="/search"
                search={{ q: chip.q }}
                className="inline-flex min-h-11 items-center rounded-pill bg-surface px-3.5 py-2 text-[13px] font-medium text-ink no-underline transition-colors duration-short ease-default hover:bg-electric-50 hover:text-electric-800 active:bg-electric-50 active:text-electric-800 focus-visible:outline-2 focus-visible:outline-electric-700 focus-visible:outline-offset-2"
              >
                {chip.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </section>
  );
}

export { HeroSection };
